var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "common-content",
    [
      _c("div", { staticClass: "us-show" }, [
        _c("img", { attrs: { src: _vm.pageData[0].mainImg, alt: "" } })
      ]),
      _c("page-title", { attrs: { pageName: _vm.pageData[0].title } }),
      _c("div", { staticClass: "us-text" }, [
        _c("div", {
          domProps: { innerHTML: _vm._s(_vm.reads(_vm.pageData[0].content)) }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62f43171", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f43171","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/garden/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-62f43171","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/garden/index.vue
// module chunks = 12